import { render, staticRenderFns } from "./AddFilesSection.vue?vue&type=template&id=7ae4e3a0&"
import script from "./AddFilesSection.vue?vue&type=script&lang=js&"
export * from "./AddFilesSection.vue?vue&type=script&lang=js&"
import style0 from "./AddFilesSection.vue?vue&type=style&index=0&id=7ae4e3a0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports